<template>
  <div class="loading-wrap" v-show="visible">
    <a-spin />
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false
    }
  }
}
</script>

<style scoped lang="scss">
  .loading-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    // background: rgba(0, 0, 0, 0.01);
  }
</style>
